import { useSelector } from 'react-redux';

export const getCurrentLocale = () => {
  const { locale } = useSelector((state) => state.app.context);
  return locale === 'en_AU@NZD' ? 'NZ' : 'AU';
};
